import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRRtm = createSelector([selectQbrState], (state) => state.rtm)
